import Phaser from 'phaser';

import AnimationKeys from '../constants/AnimationKeys';
import SceneKeys from '../constants/SceneKeys';
import TextureKeys from '../constants/TextureKeys';
import bgRepeatImage from '../../../assets/images/MouseInfinity/House01/Background/bg_repeat_340x640.png';
import mouseHoleImage from '../../../assets/images/MouseInfinity/House01/Objects/object_mousehole.png';
import window1Image from '../../../assets/images/MouseInfinity/House01/Objects/object_window1.png';
import window2Image from '../../../assets/images/MouseInfinity/House01/Objects/object_window2.png';
import bookcase1Image from '../../../assets/images/MouseInfinity/House01/Objects/object_bookcase1.png';
import bookcase2Image from '../../../assets/images/MouseInfinity/House01/Objects/object_bookcase2.png';
import LaserEndImage from '../../../assets/images/MouseInfinity/House01/Objects/object_laser_end.png';
import LaserMiddleImage from '../../../assets/images/MouseInfinity/House01/Objects/object_laser.png';
import CoinImage from '../../../assets/images/MouseInfinity/House01/Objects/object_coin.png';
import rocketMouseData from '../../../assets/images/MouseInfinity/RocketMouse/characters/rocket-mouse.json';
import rocketMouseTexture from '../../../assets/images/MouseInfinity/RocketMouse/characters/rocket-mouse.png';

class Preloader extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Preloader);
  }

  preload() {
    this.load.image(TextureKeys.Background, bgRepeatImage);

    this.load.image(TextureKeys.MouseHole, mouseHoleImage);

    this.load.image(TextureKeys.Window1, window1Image);

    this.load.image(TextureKeys.Window2, window2Image);

    this.load.image(TextureKeys.Bookcase1, bookcase1Image);

    this.load.image(TextureKeys.Bookcase2, bookcase2Image);

    this.load.image(TextureKeys.LaserEnd, LaserEndImage);

    this.load.image(TextureKeys.LaserMiddle, LaserMiddleImage);

    this.load.image(TextureKeys.Coin, CoinImage);

    this.load.atlas(
      TextureKeys.RocketMouse,
      rocketMouseTexture,
      rocketMouseData,
    );
  }

  create() {
    this.createRunAnimation();
    this.createFallAnimation();
    this.createFlyAnimation();
    this.createDeathAnimation();
    this.createFlameAnimation();
    this.scene.start(SceneKeys.Main);
  }

  createRunAnimation() {
    this.anims.create({
      key: AnimationKeys.RocketMouseRun,
      // frames: [
      //   { key: 'rocket-mouse', frame: 'rocketmouse_run01.png' },
      //   { key: 'rocket-mouse', frame: 'rocketmouse_run02.png' },
      //   { key: 'rocket-mouse', frame: 'rocketmouse_run03.png' },
      //   { key: 'rocket-mouse', frame: 'rocketmouse_run04.png' },
      // ],
      frames: this.anims.generateFrameNames(TextureKeys.RocketMouse, {
        start: 1,
        end: 4,
        prefix: 'rocketmouse_run',
        zeroPad: 2,
        suffix: '.png',
      }),
      frameRate: 10,
      repeat: -1, // loop forever
    });
  }

  createFallAnimation() {
    this.anims.create({
      key: AnimationKeys.RocketMouseFall,
      frames: this.anims.generateFrameNames(TextureKeys.RocketMouse, {
        start: 1,
        end: 1,
        prefix: 'rocketmouse_fall',
        zeroPad: 2,
        suffix: '.png',
      }),
    });
  }

  createFlyAnimation() {
    this.anims.create({
      key: AnimationKeys.RocketMouseFly,
      frames: this.anims.generateFrameNames(TextureKeys.RocketMouse, {
        start: 1,
        end: 1,
        prefix: 'rocketmouse_fly',
        zeroPad: 2,
        suffix: '.png',
      }),
    });
  }

  createDeathAnimation() {
    this.anims.create({
      key: AnimationKeys.RocketMouseDead,
      frames: this.anims.generateFrameNames(TextureKeys.RocketMouse, {
        start: 1,
        end: 2,
        prefix: 'rocketmouse_dead',
        zeroPad: 2,
        suffix: '.png',
      }),
    });
  }

  createFlameAnimation() {
    this.anims.create({
      key: AnimationKeys.RocketFlamesOn,
      frames: this.anims.generateFrameNames(TextureKeys.RocketMouse, {
        start: 1,
        end: 2,
        prefix: 'flame',
        suffix: '.png',
      }),
      frameRate: 10,
      repeat: -1, // loop forever
    });
  }
}

export default Preloader;
